import Vue from 'vue';

export default {
  LOCAL_ADD_WORK_INSTRUCTION_PACKAGE: (state, payload) => {
    state.workInstructionPackages.push(payload);
  },
  LOCAL_DELETE_WORK_INSTRUCTION_PACKAGE: (state, { packageId }) => {
    state.workInstructionPackages = state.workInstructionPackages.filter(
      (pkg) => pkg._id !== packageId
    );
    if (state.currentWorkInstructionPackage?._id === packageId) {
      state.currentWorkInstructionPackage = null;
      state.currentWorkInstruction = [];
    }
  },
  LOCAL_GET_WORK_INSTRUCTION_PACKAGES: (state, payload) => {
    state.workInstructionPackages = payload;
  },
  LOCAL_SET_CURRENT_WORK_INSTRUCTION_PACKAGE: (state, payload) => {
    state.currentWorkInstructionPackage = payload;
  },
  LOCAL_ADD_WORK_INSTRUCTION: (state, payload) => {
    state.currentWorkInstruction.push(payload);
  },
  LOCAL_UPDATE_WORK_INSTRUCTION: (state, payload) => {
    const instructionIndex = state.currentWorkInstruction.findIndex(
      (wi) => wi._id === payload._id
    );

    if (instructionIndex === -1) {
      return;
    }

    const currentInstruction = state.currentWorkInstruction[instructionIndex];
    state.currentWorkInstruction.splice(instructionIndex, 1, {
      ...currentInstruction,
      ...payload,
    });
  },
  LOCAL_DELETE_WORK_INSTRUCTION: (state, payload) => {
    state.currentWorkInstruction = state.currentWorkInstruction.filter(
      (wi) => wi._id !== payload.instructionId
    );
  },
  LOCAL_ADD_WORK_INSTRUCTION_STEP: (state, payload) => {
    const instruction = state.currentWorkInstruction.find(
      (wi) => wi._id === payload.instructionId
    );
    if (instruction) {
      if (instruction.steps === undefined) {
        Vue.set(instruction, 'steps', []);
      }
      instruction.steps.push(payload.step);
    }
  },
  LOCAL_UPDATE_WORK_INSTRUCTION_STEP: (state, payload) => {
    const instruction = state.currentWorkInstruction.find(
      (wi) => wi._id === payload.instructionId
    );

    if (!instruction || !instruction.steps) {
      return;
    }

    const stepIndex = instruction.steps.findIndex(
      (step) => step._id === payload.step._id
    );
    if (stepIndex === -1) {
      return;
    }

    instruction.steps.splice(stepIndex, 1, {
      ...instruction.steps[stepIndex],
      ...payload.step,
    });
  },
  LOCAL_DELETE_WORK_INSTRUCTION_STEP: (state, payload) => {
    const instruction = state.currentWorkInstruction.find(
      (wi) => wi._id === payload.instructionId
    );

    if (!instruction || !instruction.steps) {
      return;
    }

    instruction.steps = instruction.steps.filter(
      (step) => step._id !== payload.stepId
    );
  },

  LOCAL_SET_WORK_INSTRUCTION_PACKAGES: (state, payload) => {
    state.workInstructionPackages = payload;
  },

  LOCAL_SET_WORK_INSTRUCTIONS_FOR_PACKAGE: (state, payload) => {
    if (state.currentWorkInstructionPackage) {
      state.currentWorkInstruction = payload;
    }
  },

  LOCAL_SET_FILES_LINKED_TO_WORK_INSTRUCTION_STEP: (state, payload) => {
    const { instructionId, files, stepId } = payload;
    const instruction = state.currentWorkInstruction.find(
      (wi) => wi._id === instructionId
    );
    if (instruction && instruction.steps) {
      const step = instruction.steps.find((s) => s._id === stepId);
      if (step) {
        Vue.set(step, 'linkedDocuments', files);
      }
    }
  },

  LOCAL_SET_TASKS_TO_WORK_INSTRUCTION_STEP: (state, payload) => {
    const { instructionId, tasks, stepId } = payload;
    const instruction = state.currentWorkInstruction.find(
      (wi) => wi._id === instructionId
    );
    if (instruction && instruction.steps) {
      const step = instruction.steps.find((s) => s._id === stepId);
      if (step) {
        Vue.set(step, 'linkedTasks', tasks);
      }
    }
  },
  LOCAL_SET_FILES_LINKED_TO_WORK_INSTRUCTION: (
    state,
    { instructionId, files }
  ) => {
    const instruction = state.currentWorkInstruction.find(
      (wi) => wi._id === instructionId
    );
    if (instruction) {
      Vue.set(instruction, 'linkedDocuments', files);
    }
  },

  LOCAL_SET_TASKS_TO_WORK_INSTRUCTION: (state, { instructionId, tasks }) => {
    const instruction = state.currentWorkInstruction.find(
      (wi) => wi._id === instructionId
    );
    if (instruction) {
      Vue.set(instruction, 'linkedTasks', tasks);
    }
  },

  LOCAL_CHANGE_WORK_INSTRUCTIONS_ORDER: (state, payload) => {
    const { instructionId, targetInstructionId } = payload;
    const workInstructions = state.currentWorkInstruction || [];

    const fromIndex = workInstructions.findIndex(
      (wi) => wi._id === instructionId
    );
    const toIndex = workInstructions.findIndex(
      (wi) => wi._id === targetInstructionId
    );

    if (fromIndex === -1 || toIndex === -1 || fromIndex === toIndex) {
      return;
    }

    const [movedInstruction] = workInstructions.splice(fromIndex, 1);
    workInstructions.splice(toIndex, 0, movedInstruction);
  },
  LOCAL_CHANGE_WORK_INSTRUCTION_STEPS_ORDER: (state, payload) => {
    const { instructionId, stepId, targetStepId } = payload;
    const instruction = state.currentWorkInstruction?.find(
      (wi) => wi._id === instructionId
    );

    if (!instruction || !instruction.steps) {
      return;
    }

    const fromIndex = instruction.steps.findIndex(
      (step) => step._id === stepId
    );
    const toIndex = instruction.steps.findIndex(
      (step) => step._id === targetStepId
    );

    if (fromIndex === -1 || toIndex === -1 || fromIndex === toIndex) {
      return;
    }

    const [movedStep] = instruction.steps.splice(fromIndex, 1);
    instruction.steps.splice(toIndex, 0, movedStep);
  },

  LOCAL_SIGN_OFF_STEP: (
    state,
    { instruction, step, timestamp, userFullName, userId }
  ) => {
    const stateInstruction = state.currentWorkInstruction.find(
      (wi) => wi._id === instruction._id
    );

    const stateStep = stateInstruction.steps.find((s) => s._id === step._id);
    Vue.set(stateStep, 'signedAt', timestamp);
    Vue.set(stateStep, 'signedByFullName', userFullName);
    Vue.set(stateStep, 'signedBy', userId);
  },
};
